import { createMutation } from '@magicdoorinc/ui';
import { createSignal } from 'solid-js';
import { auth } from '~/config/auth';
import { createMagicDoorContext } from '~/contexts/utils';
import type { CompanyOptionDto } from '@magicdoorinc/auth';
import type { SendMagicLinkDto } from '~/swagger/portal/Api';

export enum MagicLinkStep {
  InputEmail = 'InputEmail',
  SelectCompany = 'SelectCompany',
}

enum MagicLinkTips {
  Sent = 'Magic link sent! Please check your email for a link to sign in.',
  SelectCompany = 'This email is associated with multiple companies. Please select the company you want to sign in to.',
}

export const [MagicLinkLoginProvider, useMagicLinkLogin] = createMagicDoorContext('MagicLinkLogin', () => {
  const [loginStep, setLoginStep] = createSignal<MagicLinkStep>(MagicLinkStep.InputEmail);
  const [companies, setCompanies] = createSignal<CompanyOptionDto[]>([]);
  const [tip, setTip] = createSignal();

  const sendMagicLink = createMutation(async (data: SendMagicLinkDto) => {
    const result = await auth.sendMagicLink(data);
    if (result.companies?.length) {
      setLoginStep(MagicLinkStep.SelectCompany);
      setCompanies(result.companies);
      setTip(MagicLinkTips.SelectCompany);
    } else {
      setTip(MagicLinkTips.Sent);
    }
  });

  const verifyMagicLink = createMutation(async (data: { token: string; redirect?: string }) => {
    await auth.initiateOAuthFlow(data.token);
    auth.setRedirect(data.redirect ?? '/');
  });

  return {
    loginStep,
    setLoginStep,
    sendMagicLink,
    verifyMagicLink,
    tip,
    companies,
  };
});
